import React from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

import "./ResultsCombinations.scss";

const ResultsCombinationsComponent = ({ combinationsResults }) => {
  return combinationsResults.length === 0 ? (
    <div>There are no combinations satisfying the search criteria.</div>
  ) : (
    <div className="ResultsCombinations results-list">
      <AutoSizer>
        {({ height, width }) => (
          <FixedSizeList
            height={height}
            width={width}
            itemCount={combinationsResults.length}
            itemSize={34}
          >
            {({ index, style }) => {
              const combination = combinationsResults[index];
              return (
                <div style={style}>
                  <div
                    className="MultiSearchPage__result-row row combination"
                    key={combination.tid}
                  >
                    <div className="col-xs-12 combination-name">
                      <Link
                        title={`${combination.name || "[Noname]"} (${
                          combination.code
                        })`}
                        to={`/view/Combination/${combination.tid}`}
                        target="_blank"
                      >
                        {`${combination.name || "[No name]"} (${
                          combination.code
                        })`}
                      </Link>
                    </div>
                  </div>
                </div>
              );
            }}
          </FixedSizeList>
        )}
      </AutoSizer>
    </div>
  );
};

export const ResultsCombinations = observer(ResultsCombinationsComponent);
